import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom'
import { findById as findCountryById } from '../../../js/countries'
import { findById as findStateById } from '../../../js/states'

// Every near neighbour the name rules refused, with the reason.
//
// Always rendered, never hidden behind a "show more" that depends on the list
// being long: a low proposal count is a signal to read this, not evidence the data
// is clean. A run over 4488 courses once proposed 2 groups and dropped 78, with 41
// of the blocking pairs less than 25 m apart — courses on the same tee, entered
// twice under names nobody would guess were the same place.
// Where to go to do something about a refused pair.
//
// The merges page cannot act on these -- that is the point of them, the rules declined --
// so the only way through is by hand, from the country page's admin table. That page is
// addressed by short code and, in a country that has states, per state; anything we cannot
// address gets no link rather than a link to the wrong list.
const countryPageFor = (country, state, ids) => {
  const inCountry = findCountryById(country)
  if (!inCountry) return null
  const inState = state ? findStateById(state) : null
  const path = inState ? `/country/${inCountry.short}/${inState.short}` : `/country/${inCountry.short}`
  return `${path}?merge=${ids.join(',')}`
}

export default function DroppedMembers({ dropped, oversized, country }) {
  return (
    <Accordion className="mt-3">
      <Accordion.Item eventKey="dropped">
        <Accordion.Header>
          {dropped.length} cluster members the rules refused
        </Accordion.Header>
        <Accordion.Body>
          {dropped.length === 0 ? (
            <p className="text-muted mb-0">Nothing was refused.</p>
          ) : (
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Survivor</th>
                  <th>Other</th>
                  <th>Relation</th>
                  <th>Distance</th>
                  <th>Score</th>
                  <th>Outcome</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {dropped.map((row, index) => {
                  const merge = countryPageFor(country, row.state, [
                    row.survivorId,
                    row.otherId,
                  ])
                  return (
                  <tr key={`${row.survivorId}-${row.otherId}-${index}`}>
                    <td>
                      <Link to={`/course/${row.survivorId}`}>{row.survivorName}</Link>
                    </td>
                    <td>
                      <Link to={`/course/${row.otherId}`}>{row.otherName}</Link>
                    </td>
                    <td className="small">{row.relation}</td>
                    <td>
                      {row.metres == null ? (
                        <span className="text-muted small">no location</span>
                      ) : (
                        `${row.metres} m`
                      )}
                    </td>
                    {/* What it did score, so a near miss is distinguishable from a
                        flat refusal — and so a threshold that is too strict shows up
                        as a column of 38s rather than as silence. */}
                    <td>{row.score}</td>
                    <td className="small text-muted">{row.outcome}</td>
                    {/* The two of them, side by side, on the one page that can merge them
                        by hand. A new tab rather than a navigation: you are working down
                        this list, and losing your place in it to check one pair is how a
                        list of seventy-eight stops getting read. */}
                    <td>
                      {merge && (
                        <a
                          href={merge}
                          target="_blank"
                          rel="noreferrer"
                          title="Open both on the country page to merge them by hand"
                          className="bi-box-arrow-up-right"
                        >
                          {' '}
                        </a>
                      )}
                    </td>
                  </tr>
                  )
                })}
              </tbody>
            </Table>
          )}
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="oversized">
        <Accordion.Header>
          {oversized.length} clusters too large to be duplicates
        </Accordion.Header>
        <Accordion.Body>
          <p className="text-muted small">
            Usually a park with several courses in it rather than a pile of
            duplicates, so these are reported and never proposed. Names shared by two
            or more members inside such a cluster are split out and proposed
            separately.
          </p>
          {oversized.map((cluster, index) => (
            <p key={index} className="small mb-1">
              <strong>{cluster.size}</strong> near {cluster.nearName}:{' '}
              {cluster.names.join(', ')}
            </p>
          ))}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}
